import { render, staticRenderFns } from "./PricingKeyPlan.vue?vue&type=template&id=452a80ce&scoped=true&"
import script from "./PricingKeyPlan.vue?vue&type=script&lang=js&"
export * from "./PricingKeyPlan.vue?vue&type=script&lang=js&"
import style0 from "./PricingKeyPlan.vue?vue&type=style&index=0&id=452a80ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a80ce",
  null
  
)

export default component.exports